import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { pickHTMLProps } from 'pick-react-known-prop';
import GridAreaContainer from '@sprinx/react-mui-components/GridAreaContainer';
import Portal from '@material-ui/core/Portal';
import Container from '@material-ui/core/Container';
var useStyles = makeStyles(function (theme) {
  return {
    root: {},
    fixedMenu: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: theme.zIndex.appBar
    },
    menu: {},
    hide: {
      opacity: 0
    }
  };
}, {
  name: 'SxComProductDetailSpagetty'
});
var ProductDetailSpagetty = /*#__PURE__*/React.forwardRef(function ProductDetailSpagetty(_ref, ref) {
  var children = _ref.children,
      pClasses = _ref.classes,
      className = _ref.className,
      ContainerProps = _ref.ContainerProps,
      renderNavigation = _ref.renderNavigation,
      renderToGridArea = _ref.renderToGridArea,
      rest = _objectWithoutProperties(_ref, ["children", "classes", "className", "ContainerProps", "renderNavigation", "renderToGridArea"]);

  var classes = useStyles({
    classes: pClasses,
    className: className
  });

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      fixedNavi = _React$useState2[0],
      setFixedNavi = _React$useState2[1];

  var innerRef = React.useRef();
  React.useImperativeHandle(ref, function () {
    return innerRef.current.offsetTop;
  });
  var handleCheckPosition = React.useCallback(function () {
    var containerPosition = innerRef.current.offsetTop;
    var windowPosition = window.pageYOffset;

    if (containerPosition <= windowPosition) {
      setFixedNavi(true);
    } else if (containerPosition > windowPosition && fixedNavi) {
      setFixedNavi(false);
    }
  }, [fixedNavi]);
  React.useEffect(function () {
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', handleCheckPosition);
      return function () {
        window.removeEventListener('scroll', handleCheckPosition);
      };
    }

    return null;
  }, [handleCheckPosition]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GridAreaContainer, _extends({}, pickHTMLProps(rest), {
    className: clsx(classes.root, className),
    ref: innerRef,
    renderToGridArea: renderToGridArea
  }), /*#__PURE__*/React.createElement("div", {
    className: clsx(classes.menu, fixedNavi && classes.hide)
  }, renderNavigation({
    fixedNavigation: fixedNavi
  })), children), /*#__PURE__*/React.createElement(Portal, null, fixedNavi && /*#__PURE__*/React.createElement("div", {
    className: clsx(classes.fixedMenu, classes.menu)
  }, /*#__PURE__*/React.createElement(Container, ContainerProps, renderNavigation({
    fixedNavigation: fixedNavi
  })))));
});
ProductDetailSpagetty.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.shape({
    fixedMenu: PropTypes.string,
    hide: PropTypes.string,
    menu: PropTypes.string,
    root: PropTypes.string
  }),
  className: PropTypes.string,
  ContainerProps: PropTypes.shape({}),
  renderNavigation: PropTypes.func.isRequired,
  renderToGridArea: PropTypes.string
};
ProductDetailSpagetty.defaultProps = {
  children: undefined,
  classes: undefined,
  className: undefined,
  ContainerProps: undefined,
  renderToGridArea: 'parameters'
};
export default ProductDetailSpagetty;